// hooks/useInactivityLogout.ts
import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../store';
import { useLogout } from './api/useLogout';

const INACTIVITY_TIMEOUT =
  (parseInt(process.env.REACT_APP_AUTH_IN_ACTIVITY_MIN || '90') as number) * 60 * 1000; // 90 minutes in milliseconds

export const useInactivityLogout = () => {
  const dispatch = useDispatch();
  const { isAuthenticated, loginTime } = useSelector((state: RootState) => state.user);

  const { logout } = useLogout();

  const isLoggingOut = useRef(false);

  useEffect(() => {
    if (!isAuthenticated || !loginTime) return;

    const checkInactivity = () => {
      const now = Date.now();
      const timeLeft = loginTime + INACTIVITY_TIMEOUT - now;

      if (timeLeft <= 0) {
        console.log('Session expired due to inactivity');
        logout();
        // Optional: redirect to login
      }
    };

    // Check every 10 seconds
    const interval = setInterval(checkInactivity, 10000);

    // Reset timer on any user activity
    // const resetTimer = () => {
    //   if (isAuthenticated) {
    //     dispatch({ type: 'user/updateLastActivity' });
    //   }
    // };

    // const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click'];
    // events.forEach((event) => window.addEventListener(event, resetTimer, true));

    // Initial check
    checkInactivity();

    return () => {
      clearInterval(interval);
      //   events.forEach((event) => window.removeEventListener(event, resetTimer, true));
    };
  }, [isAuthenticated, loginTime, dispatch, logout]);

  useEffect(() => {
    if (!isAuthenticated) {
      isLoggingOut.current = false;
      return;
    }

    const AUTH_TOKEN_KEY = 'states';

    const checkLocalStorage = () => {
      if (isLoggingOut.current) return;

      const token = localStorage.getItem(AUTH_TOKEN_KEY);

      if (isAuthenticated && !token) {
        isLoggingOut.current = true;
        logout();
      }
    };

    checkLocalStorage();

    const interval = setInterval(checkLocalStorage, 1000);

    const handleStorageChange = (e: StorageEvent) => {
      if (isLoggingOut.current) return;

      if (e.key === AUTH_TOKEN_KEY && e.newValue === null && isAuthenticated) {
        isLoggingOut.current = true;
        logout();
      }
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      clearInterval(interval);
      window.removeEventListener('storage', handleStorageChange);
    };
  }, [isAuthenticated, logout]);
};
